import WineVarietalIcon from './WineVarietalIcon';

export default WineVarietalIcon;
